import DOMReady from '../utils/DomReady';

DOMReady(() => { 
  
  const ev = document.querySelectorAll('.hide-row');
  ev && ev.forEach(item => {
    
    item.addEventListener('click', event => {
      item.closest('tr').classList.add('afd-hide')
    })
  })
})

